import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import Switch from '@mui/material/Switch';
import Box from '@mui/material/Box';
import DEFAULT_SWITCH_CLASS_NAME from '../../theme/constants/switch';

const BooleanSwitchFilter = ({
  customVariables,
  setCustomVariables,
  label,
  checkedKey,
  checkedValue,
  onCustomVariables,
  offCustomVariables,
}) => {
  const isChecked = (customVariables?.[checkedKey] ?? checkedValue) === checkedValue;

  const handleOnChange = (event, value) => {
    const nextCustomVariables = value ? onCustomVariables : offCustomVariables;
    setCustomVariables((prev) => ({
      ...prev,
      ...nextCustomVariables,
    }));
  };

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Switch
        className={DEFAULT_SWITCH_CLASS_NAME}
        onChange={handleOnChange}
        checked={isChecked}
      />
      <Typography variant="small_2">{label}</Typography>
    </Box>
  );
};

BooleanSwitchFilter.propTypes = {
  customVariables: PropTypes.shape(),
  setCustomVariables: PropTypes.func.isRequired,
  label: PropTypes.string,
  checkedKey: PropTypes.string,
  checkedValue: PropTypes.bool,
  onCustomVariables: PropTypes.shape(),
  offCustomVariables: PropTypes.shape(),
};

BooleanSwitchFilter.defaultProps = {
  customVariables: {},
  label: '',
  checkedKey: '',
  checkedValue: true,
  onCustomVariables: {},
  offCustomVariables: {},
};

export default BooleanSwitchFilter;
